module.exports = __webpack_public_path__ + "img/Frame-34.a92c2824.svg";